// api-plugin.js
import * as api from '../api';

export default {
    install: (app) => {
        // Add your API methods to the global Vue instance or provide them as a plugin
        app.config.globalProperties.$api = api;
    }
};